import { registerLocaleData } from '@angular/common';
import localeEnAu from '@angular/common/locales/en-AU';
import { LOCALE_ID, Provider } from '@angular/core';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { provideDateFnsAdapter } from '@angular/material-date-fns-adapter';
import { enAU } from 'date-fns/locale';
import { AU_DATE_FORMATS } from './au-date-formats';
import { BrisbaneDateFnsAdapter } from './brisbane-date-fns-adapter';

registerLocaleData(localeEnAu);

export const AUSTRALIAN_LOCALE_PROVIDERS: Provider[] = [
  { provide: LOCALE_ID, useValue: 'en-AU' },
  { provide: MAT_DATE_LOCALE, useValue: enAU },
  ...provideDateFnsAdapter(AU_DATE_FORMATS),
  { provide: DateAdapter, useClass: BrisbaneDateFnsAdapter },
];
